import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import RfMonthlyLimitAddModalUI from './RfMonthlyLimitAddModalUI.js'

class RfMonthlyLimitAddModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      month: '',
      monthError: null,
      year: '',
      yearError: null,
      amount: '',
      amountError: null,
    }
  }

  render() {
    let monthList = [
      { key: '1', value: 'January' },
      { key: '2', value: 'February' },
      { key: '3', value: 'March' },
      { key: '4', value: 'April' },
      { key: '5', value: 'May' },
      { key: '6', value: 'June' },
      { key: '7', value: 'July' },
      { key: '8', value: 'August' },
      { key: '9', value: 'September' },
      { key: '10', value: 'October' },
      { key: '11', value: 'November' },
      { key: '12', value: 'December' },
    ]
    return (
      <RfMonthlyLimitAddModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        month={this.state.month}
        onMonthChange={(event) => { this.setState({ month: event.target.value }) }}
        monthError={this.state.monthError}
        setMonthError={(error) => { this.setState({ monthError: error }) }}
        monthList={monthList}
        //
        year={this.state.year}
        onYearChange={(event) => { this.setState({ year: event.target.value }) }}
        yearError={this.state.yearError}
        setYearError={(error) => { this.setState({ yearError: error }) }}
        yearList={this.state.yearList}
        //
        amount={this.state.amount}
        onAmountChange={(event) => { this.setState({ amount: event.target.value }) }}
        amountError={this.state.amountError}
        setAmountError={(error) => { this.setState({ amountError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getYears(context)
    Modal.setAppElement('body')
  }

  getYears(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/years`,
      cacheKey: CacheKeys.Years(),
      callback: this.getYearsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getYearsCallback = (response) => {
    let yearList = response.yearList.map((years) => {
      return { value: years, label: years }
    })
    this.setState({ yearList: yearList })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/monthly/summaries`,
      this.onSubmitCallback, {
      year: this.state.year,
      month: this.state.month,
      amount: this.state.amount
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(RfMonthlyLimitAddModalSF)
